/** Faz 8 — شاشة تقرير المبيعات في تطبيق Android (F8-16)، بالعربية. تُضاف إلى `mobile.ar.ts` بسطر واحد (ADR-801). */
export const mobileFaz8Ar = {
  salesReport: {
    title: 'تقرير المبيعات',
    open: 'فتح تقرير المبيعات',
    hint: 'صافي المبيعات، الطلبات، متوسط قيمة الطلب، العملاء الجدد',
    presets: { today: 'اليوم', last_7: 'آخر 7 أيام', this_month: 'هذا الشهر', last_month: 'الشهر الماضي' },
    periodLabel: 'الفترة',
    netSales: 'صافي المبيعات',
    orders: 'الطلبات',
    averageOrder: 'متوسط قيمة الطلب',
    newCustomers: 'العملاء الجدد',
    deductions: 'المرتجعات والإلغاءات',
    itemsSold: 'الوحدات المباعة',
    vsPrevious: '{{change}} مقارنة بالفترة السابقة',
    up: 'ارتفاع بنسبة {{pct}}%',
    down: 'انخفاض بنسبة {{pct}}%',
    flat: 'دون تغيير',
    new: 'لا شيء في الفترة السابقة',
    dailyTitle: 'حسب اليوم',
    dailyRow: '{{orders}} طلبات',
    topProducts: 'المنتجات الأكثر مبيعًا',
    productRow: '{{quantity}} وحدات',
    noSales: 'لا توجد مبيعات في هذه الفترة.',
    partial: 'لم تنتهِ الفترة بعد؛ قد تتغير أرقام اليوم.',
    awaiting: '{{count}} طلبات بانتظار الدفع ({{amount}}) لا تُحتسب ضمن المبيعات.',
    fxMissing: 'استُبعدت {{count}} طلبات بعملة أجنبية دون سعر صرف.',
    definition:
      'الطلبات المؤكدة (مدفوعة، قيد التجهيز، مشحونة، مُسلَّمة، مكتملة)؛ المبالغ بالليرة التركية (TRY) شاملة ضريبة القيمة المضافة، بعد المرتجعات والإلغاءات. التعريف نفسه المستخدم في لوحة التحكم.',
    morePanel: 'التفاصيل والملفات والتقرير المالي متاحة في لوحة التحكم.',
    noPermission: 'يلزم امتلاك صلاحية تقارير المبيعات لعرض أرقام المبيعات.',
  },
};
